import { AudioChunk, AudioChunkProps } from './AudioChunk'
import { Position, PositionRange } from '../../types'

export class AudioBufferChunk extends AudioChunk {
  public offset: Position

  constructor(props: { offset: Position } & AudioChunkProps) {
    super(props)

    this.offset = props.offset
  }

  public cut(range: PositionRange): AudioBufferChunk | AudioBufferChunk[] {
    const chunks = super.cut(range)
    return Array.isArray(chunks)
      ? chunks.map((chunk) => this.createChunk(chunk, range))
      : this.createChunk(chunks, range)
  }

  private createChunk({ start, end }: AudioChunk, range: PositionRange): AudioBufferChunk {
    const delta = start === range[0] ? start - this.start + (range[1] - range[0]) : 0
    const offset = this.offset + delta
    return new AudioBufferChunk({ start, end, offset })
  }
}
